import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronUp, faChevronDown, faChevronRight, faChevronLeft, faChartLine,
  faCommentsAlt, faExclamationTriangle, faCalendarAlt, faChartBar, faClock, faImage, faListAlt, faPlayCircle, faPauseCircle } from '@fortawesome/pro-regular-svg-icons'

library.add(faChevronUp, faChevronDown, faChevronRight, faChevronLeft, faChartLine,
  faCommentsAlt, faExclamationTriangle, faCalendarAlt, faChartBar, faClock, faImage, faListAlt, faPlayCircle, faPauseCircle);
